<template lang="html">
  <div class="answer">
    <div class="interview-answer-text set-after">
      <label :for="'answer' + this.id">Answer</label>
      <textarea :name="'questions[' + this.id + '][answer]'" :id="'answer' + this.id" cols="30" rows="5"
                class="wysiwyg-please long-input" v-on:keyup="textareaChange">{{ oldAnswer.answer }}</textarea>
    </div>
    <div class="interview-answer-images set-after">
      <label>Related images (optional)</label>
      <image-inputs-list :prohibition='this.validation || disabled'
                         :minId="this.id * 20"
                         :idCoefficient="20000"
                         :images="this.oldAnswer.images"
                         :interviewImages="fullQuestion.images"
                         :disabled-video="true"
                         :validation="validation"
                         :entity="entity"
                         @contentUploaded="prepareImagesIds"></image-inputs-list>
    </div>
    <div class="set-after">
      <label :for="'link' + this.id">Upload Video (optional)</label>

      <input class="video-path" type="hidden" :name="'questions[' + this.id + '][video_path]'" :value="oldAnswer.video_path">

      <UploadVideo
          :disabled="validation || disabled"
          input-name="video_path"
          :url="routeUploadVideo"
          :name="oldAnswer.video_name"
          v-model="oldAnswer.video_path"
      />
    </div>
    <input type="hidden" class="answer__images-ids" :name="'questions[' + this.id + '][sorted_images_ids]'"
           v-model="imageIds">
  </div>
</template>

<script>
// Component display expanded question. Used for interview page
import UploadVideo from './UploadVideo';

export default {
  props: ['id', 'answer', 'validation', 'routeUploadVideo', 'disabled', 'fullQuestion', 'entity'],

  components: {
    UploadVideo
  },

  data() {
    return {
      imageIds: null,
      oldAnswer: {
        images: null,
        video_path: ''
      }
    };
  },
  methods: {
    prepareImagesIds(input) {
      let filteredImages = window._.filter(input.content, (input) => {return input.type === 'image';});

      this.imageIds = window._.compact(window._.map(filteredImages, 'imageId'));
    },
    textareaChange(e) {
      $(this.$el).find('.interview-answer-text .interview-validation').remove();
    },
    prepareExistingImageIds() {
      if (!this.fullQuestion.images) return;

      this.imageIds = this.fullQuestion.images.filter(image => image.id).map(image => image.id);
    },
  },
  created() {
    if (this.answer) {
      this.oldAnswer = this.answer;
    }
  },
  mounted() {
    CKEDITOR.replace($(this.$el).find('.wysiwyg-please').attr('name'), {
      uiColor: '#dddddd'
    });

    CKEDITOR.instances[$(this.$el).find('.wysiwyg-please').attr('id')].on('change', () => {
      $(this.$el).find('.interview-answer-text .interview-validation').remove();
    });

    if (this.fullQuestion) {
      this.prepareExistingImageIds();
    }
  }
};
</script>